// extracted by mini-css-extract-plugin
module.exports = {"inline":"Inline_inline__Vt3rA","asSection":"Inline_asSection__imTQB","headingContainer":"Inline_headingContainer__jFrwi","item":"Inline_item__PymYb"};